import { motion } from "framer-motion";

const STATS = [
  { value: "$0", label: "Commission per order" },
  { value: "3 min", label: "Instant menu updates" },
  { value: "99.9%", label: "Platform uptime" },
  { value: "24/7", label: "Dedicated AU support" },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-36 bg-[#12141c] overflow-hidden">
      <div className="pointer-events-none absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-amber-500/10 blur-[140px]" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <motion.div
          className="lg:col-span-6"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="eyebrow mb-5">About Coding In Store</p>
          <h2 data-testid="about-headline" className="font-display font-semibold text-white tracking-tight leading-[1.05] text-3xl sm:text-5xl">
            Engineered for the heat of{" "}
            <span className="italic text-amber-500">independent food retail.</span>
          </h2>
          <p data-testid="about-body" className="mt-7 text-base sm:text-lg text-gray-400 leading-relaxed max-w-xl">
            We build enterprise-grade direct ordering technology for independent food entrepreneurs.
            Whether you run a high-volume doner spit, a traditional chippy, or a bustling neighbourhood
            café, onlinekebab.store hands you back control of your customer relationships, your drivers
            and your margins.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
            {STATS.map((s, i) => (
              <motion.div
                key={s.label}
                data-testid={`about-stat-${i}`}
                className="bg-[#0b0c10] p-6 sm:p-7"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.08 * i, duration: 0.6 }}
              >
                <div className="font-display text-3xl sm:text-4xl font-semibold text-amber-500">{s.value}</div>
                <div className="mt-2 font-mono-x text-[11px] tracking-[0.18em] uppercase text-gray-500">{s.label}</div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="lg:col-span-6 relative"
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="clip-frame relative border border-amber-500/25 shadow-[0_30px_80px_rgba(0,0,0,0.5)]">
            <img
              src="https://images.unsplash.com/photo-1774028156636-e514fa039c19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxrZWJhYiUyMHJlc3RhdXJhbnQlMjBraXRjaGVuJTIwdGFrZWF3YXklMjBmb29kJTIwY291bnRlcnxlbnwwfHx8fDE3OTM3OTY3Mjd8MA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop&w=1400"
              alt="Kebab shop kitchen counter in full service"
              className="w-full h-[420px] sm:h-[520px] object-cover"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b0c10]/80 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
              <span className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-amber-400">In service, nightly</span>
              <span className="font-mono-x text-[10px] tracking-[0.3em] uppercase text-gray-400">EST. REDCLIFFE</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
